export default __webpack_public_path__ + "static/media/gridImage5.5d8ae949.png";